import RestfulService from "../common/RestfulService";

const questionnaireService = new RestfulService("/issb/questionnaire");

questionnaireService.doAddQuestionFromTemplateQuestion = (roundId, templateQuestionId) => {
  let url = `${questionnaireService.path}/${roundId}/add_question/${templateQuestionId}`;
  return questionnaireService.axios.post(url).then(({ data }) => data);
};

export default questionnaireService;
